import Vue from 'vue'
import * as  R from 'ramda'
import tap from 'tap-logger'
import debounce from 'lodash.debounce'
import {singleApplicationVue} from './single-application'
import { fontSizer, selectSlider, $getFontSize } from '../../theme-helpers'
//Tomamos singleApplicationVue como modelo, pero para no coipeistear lo clonamos y modificamos el objeto conforme lo necesitemos
const setsApplicationVue = R.clone(singleApplicationVue)

setsApplicationVue.el = '#sets-application-vue'
setsApplicationVue.watch.selectedTemplate = function() {}//evitamos que este watcher haga algo


setsApplicationVue.computed.selectedFormLabels = function() {
	return R.pipe(
		R.pathOr([], ['selectedForm', 'sets']),
		R.map(R.pick(['font'])),
		R.reject(R.isEmpty)
	)(this)
}

setsApplicationVue.watch.selectedFormLabels = function() {
	this.loadedFonts = R.pipe(
		R.map(R.path(['font', 'google_url'])),
		R.reject(R.isEmpty),
		R.concat(this.loadedFonts),
		R.uniq,
	)(this.selectedFormLabels)

	Vue.nextTick(() => { 
		this.selects.fontsSelect = selectSlider('#fonts_select_JS') 
		this.selectLabel(tap(this.selectedFormLabels[0]))	
		this.resizeFont()
	})
}

setsApplicationVue.computed.selectedSet = function() {
	let label = this.selectedLabel || {}
	return R.find(set => 
		R.equals(set.font, label.font),
		R.pathOr([], ['selectedForm', 'sets'], this)
	) || {}
}

setsApplicationVue.computed.templatesInSelectedSet = function() {
	return R.pipe(
		R.chain(R.prop('template')),
		R.chain(template => 
			template.stamps.map((stamp) =>
				({
					container: template.container,
					description: template.description,
					label: template.label,
					stamp,
					thumbnail_image: template.thumbnail_image,
				})
			)
		)
	)(this.selectedSet.labels || [])
}

setsApplicationVue.methods.resizeFont = debounce(function() {
	if(0 === R.pathOr(0, ['templatesInSelectedSet', 'length'], this)) {return} 
	this.$broadcast('resize-font')//delegamos resizeFont a los hijos, porque pueden tener contenedores de tamaño distinto
}, 200),

setsApplicationVue.computed.selectedSku = function() {
	return R.pathOr({}, ['sku'], this.selectedSet || {})
}

setsApplicationVue.events['new-font-size'] = function({id, font_size}) {
	let currentStamps = R.map(template => template.stamp.id, R.pathOr([], ['templatesInSelectedSet'], this))
	this.fontSizes = R.pipe(
		R.assoc(id, font_size),
		R.pick(currentStamps),
	)(this.fontSizes)
}


export {setsApplicationVue}